var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-fragment"},[_c('keep-alive',[(_vm.fragmentPath)?_c('AsyncComponent',_vm._b({key:_vm.fragment.postId,attrs:{"component-path":_vm.fragmentPath},on:{"back":_vm.handleBack}},'AsyncComponent',_vm.fragment,false)):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }